"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioRoutes = void 0;
exports.audioRoutes = [
    // Voice Management Routes
    {
        name: 'audio.voices',
        path: '/voices',
        method: 'GET'
    },
    {
        name: 'audio.voice-by-id',
        path: '/voices/:voiceId',
        method: 'GET'
    },
    {
        name: 'audio.recommended-voices',
        path: '/voices/recommended',
        method: 'GET'
    },
    {
        name: 'audio.azure-voices-by-gender',
        path: '/voices/azure/gender',
        method: 'GET'
    },
    {
        name: 'audio.azure-neural-voices',
        path: '/voices/azure/neural',
        method: 'GET'
    },
    {
        name: 'audio.user-info',
        path: '/user-info',
        method: 'GET'
    },
    // Text-to-Speech Routes
    {
        name: 'audio.text-to-speech',
        path: '/text-to-speech',
        method: 'POST'
    },
    {
        name: 'audio.stream-text-to-speech',
        path: '/stream-text-to-speech',
        method: 'POST'
    },
    // Speech-to-Text Routes
    {
        name: 'audio.speech-to-text',
        path: '/speech-to-text',
        method: 'POST'
    },
    // Session Management Routes
    {
        name: 'audio.create-session',
        path: '/sessions',
        method: 'POST'
    }
];
